import React from 'react';
import { Stack } from '../Stack';
import { theme } from '../../theme';
import { Wrapper, BorderedWrapper, RootLayout, InputLayout, AccessoryLayout, TextLayout, LabelText, HintText, ErrorText, BlockTooltip, } from './components/styled';
import { HelpIcon } from '../../tempIcons/HelpIcon';
export const Choice = ({ id, label, hint, tooltip, error, bordered, Badge, Accessory, Footer, children, disabled = false, }) => {
    const contentMarkup = (React.createElement(RootLayout, null,
        React.createElement(InputLayout, { align: Accessory ? 'center' : 'top' }, children),
        Accessory && React.createElement(AccessoryLayout, null, Accessory),
        label || hint || error || Badge || Footer ? (React.createElement(TextLayout, null,
            React.createElement(Stack, { direction: "horizontal", alignY: "center", spacing: "sm" },
                Badge,
                label && React.createElement(LabelText, null, label),
                tooltip && (React.createElement(BlockTooltip, { text: tooltip },
                    React.createElement(HelpIcon, { name: "help", width: theme.sizes.base, color: theme.colors.neutral.ink.lightest })))),
            hint && React.createElement(HintText, null, hint),
            error && React.createElement(ErrorText, null, error),
            Footer)) : null));
    if (bordered) {
        return (React.createElement(BorderedWrapper, { disabled: disabled, htmlFor: id }, contentMarkup));
    }
    return (React.createElement(Wrapper, { disabled: disabled, htmlFor: id }, contentMarkup));
};
//# sourceMappingURL=Choice.js.map